import * as mobx from 'mobx';
import * as mobxReact from 'mobx-react';
import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import { FormField } from '../../../../../global/form/form-field/form-field';
import { AttendeeRegistrationStatus } from '../../../../../../api/attendees.dao';
import { OEToggle } from '../../../../../global/oe-toggle/oe-toggle';
import Text from '../../../../../global/text/text';
import { AttendeeBulkUpdateFormViewModel } from './attendee-bulk-update-form.viewmodel';

interface IProps {
    formVM: AttendeeBulkUpdateFormViewModel;
    intl: IntlShape;
}

const AttendeeBulkUpdateFormBodyPresentation = injectIntl(mobxReact.observer((props: IProps) => {
    const { formVM, intl } = props;
    return (
        <form className='oe-form'>
            <div className='oe-form__body'>
                <FormField
                    label={<FormattedMessage
                        id='oe.attendee.registrationStatus'
                        description='Label text'
                        defaultMessage='Registration Status'
                    />}
                    className='w-50'
                >
                    <select
                        value={formVM.newAttendeeRegistrationStatus}
                        onChange={mobx.action(e => formVM.newAttendeeRegistrationStatus = e.target.value as AttendeeRegistrationStatus)}
                        className='oe-form-field__control'
                    >
                        {Object.keys(AttendeeRegistrationStatus).map((item: AttendeeRegistrationStatus) =>
                            <option
                                key={item}
                                value={AttendeeRegistrationStatus[item]}
                            >
                                {intl.formatMessage({
                                    id: `oe.registrationStatus.${item}`
                                })}
                            </option>
                        )}
                    </select>
                </FormField>
                <FormField>
                    <div className='row center font-size-12 send-registration-email-toggle'>
                        <OEToggle
                            isSelected={formVM.sendRegistrationEmail}
                            onClick={formVM.toggleSendRegistrationEmail}
                        />
                        <Text
                            id='oe.attendee.sendRegistrationEmail'
                            message={'Send Registration Email?'}
                        />
                    </div>
                    <div className='send-registration-email-toggle-hint'>
                        {
                            formVM.sendRegistrationEmail ? <Text
                                message='Emails will be sent to Attendees when you click Apply.'
                                id='oe.attendee.emailWillBeSentToAttendees'
                                description='Label text'
                            /> : <Text
                                message='Registration status will be updated when you click Apply, but no email will be sent.'
                                id='oe.attendee.registrationStatusWillBeUpdated'
                                description='Label text'
                            />
                        }
                    </div>
                </FormField>

            </div>

        </form>
    );
}));

export { AttendeeBulkUpdateFormBodyPresentation };
